import Entity from './Entity';

export default class Genre implements Entity {
  constructor(public id: number, public code: string, public name: string) {}
}
